<template>
  <div class="layout">
  <Layout>
    <AdminTop />
    <Layout>
    <Sider hide-trigger :style="{background: '#fff'}">
    <AdminMenu />
  </Sider>
    <Layout :style="{padding: '0 24px 24px'}">
      <AdminBread />
      <Content :style="{padding: '24px', minHeight: '280px', background: '#fff'}">
        <Space wrap style="margin: 10px 0;" v-model="status">
            <RadioGroup type="button" button-style="solid" @on-change="changeStatus">
                <Radio :label="0">待审核</Radio>
                <Radio :label="1">已审核</Radio>
            </RadioGroup>
        </Space>

        <Table border :columns="columns" :data="answers">
          <template #title="{ row }">
              <strong>{{ row.content }}</strong>
          </template>
          <template #action="{ row }">
              <Button type="success" size="small" style="margin-right: 5px" @click="answerCheck(1, row.id)">通过</Button>
              <Button type="error" size="small" @click="answerCheck(-1, row.id)" style="margin-right: 5px">不通过</Button>
              <!-- <Button type="info" size="small" @click="remove(row.id)">查看</Button> -->
          </template>
        </Table>

        <div id="pager"><Page :total="num" @on-change="pageChange" show-total /></div>
      </Content>
    </Layout>
    </Layout>
  </Layout>
  </div>
</template>
<script>
import AdminTop from '../../components/AdminTop.vue'
import AdminMenu from '../../components/AdminMenu.vue'
import AdminBread from '../../components/AdminBread.vue'
import global from '../../utils/global'
import axios from 'axios'
export default {
  components: {
    AdminTop,
    AdminMenu,
    AdminBread
  },
  data () {
    return {
      user: null,
      
      answers:[],
      page: 1,
      num: 0,
      status: 0,
      columns: [
        {
          title: '回复内容',
          slot: 'title',
          minWidth: 120
        },
        {
          title: '回复时间',
          key: 'createTime',
          width: 200
        },
        {
          title: '回复用户',
          key: 'createUserName',
          width: 126
        },
        {
          title: '状态',
          key: 'statusTxt',
          width: 80
        },
        {
          title: 'Action',
          slot: 'action',
          width: 150,
          align: 'center'
        }
      ],
    }
  },

  mounted() {
    this.initUser()
    this.questionsList()
  },
  methods: {
    //初始化用户信息
          initUser() {
        let userStr = localStorage.getItem("user")
        if(userStr!=null) {
          this.user = JSON.parse(userStr)
        } else {
          this.$router.push({path: '/'})
        }
    },

    questionsList() {
      let vm = this
      axios({
        method: 'post',
        url: global.restUrl + '/api/web/ask/v1.0/answer/list',
        data: {
          limit:10,
          page: vm.page,
          status: vm.status
        }
      }).then(function (response) {
        let success = response.data.success
        if(success) {
          let data = response.data.data
          if(data.list!=null) {
            vm.answers = data.list
          } else {
            vm.answers = []
          }
          vm.num = data.num
        }
      });
    },
    pageChange(page) {
      this.page = page
      this.questionsList()
    },
    //问题审核
    answerCheck(status, id) {
      let vm = this
      axios({
        method: 'post',
        url: global.restUrl + '/api/web/ask/v1.0/answer/check',
        data: {
          id: id,
          status: status
        },
        headers: {
          token: vm.user.token
        }
      }).then(function (response) {
        let success = response.data.success
        if(success) {
          vm.$Message.success('提交成功');
          vm.questionsList()
        }
      });
    },
    changeStatus(id) {
        this.status=id
        this.page=1
        this.questionsList()
    }
  }
}
</script>
